import { createSlice }   from '@reduxjs/toolkit';
import * as userReducers from 'Redux/Reducers/User';
import User              from 'Domain/Models/User/User';
import { Organizer }     from 'Domain/Models/Organizer/Organizer';

export interface IUserState {
  openRequests: string[],
  failedRequests: string[],
  updatedAt: number,
  currentUser: User | null
  organisations: Organizer[] | null
}

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    openRequests: [],
    failedRequests: [],
    currentUser: null,
    organisations: null,
    updatedAt: 0,
  },
  reducers: userReducers,
});
